export default __webpack_public_path__ + "static/media/travelguide.5d083743.svg";